<template>
  <div class="col-12" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
    <div class="card no-hover overflow-hidden">
      <div role="button" class="card-header d-flex align-items-center p-3 bg-blurry border-0" data-bs-toggle="collapse" :data-bs-target="'#' + slugifyQuestion">
        <h3 class="h6 mb-0" itemprop="name">
          <slot name="question"></slot>
        </h3>
        <i class="fa-solid fa-chevron-down text-primary ms-auto"></i>
      </div>
      <div class="card-body bg-blurry collapse" :id="slugifyQuestion" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
        <div itemprop="text">
          <slot name="answer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">

const slots = useSlots();

const slugifyQuestion = computed(() => {
  const questionSlotText = slots.question?.()[0]?.children || '';
  return questionSlotText
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
});
</script>